<div class="flex items-center gap-4">
  <span *ngIf="labelOff" [ngClass]="{ 'opacity-50': disabled }">{{ labelOff }}</span>

  <label
    class="relative inline-flex items-center cursor-pointer"
    [ngClass]="disabled ? 'opacity-50 pointer-events-none' : ''"
  >
    <input
      type="checkbox"
      class="sr-only"
      [checked]="checked"
      [disabled]="disabled"
      (change)="handleChange($event)"
      (blur)="handleBlur()"
    />

    <div
      class="w-12 h-6 rounded-full relative transition-colors duration-300"
      [ngClass]="checked ? 'bg-blue-500' : 'bg-secondary-300'"
    >
      <div
        class="absolute top-0.5 w-5 h-5 bg-white rounded-full shadow-md transition-transform duration-300 ease-in-out"
        [ngClass]="checked ? 'translate-x-[1.75rem]' : 'translate-x-0.5'"
      ></div>
    </div>
  </label>

  <span *ngIf="labelOn" [ngClass]="{ 'opacity-50': disabled }">{{ labelOn }}</span>
</div>
